"use client";

import { Card } from "react-bootstrap";
import { formatDate } from "../../../utils";

interface ShippingDetailsProps {
  order: any;
}

const ShippingDetails = ({ order }: ShippingDetailsProps) => {
  const hasSnapshot = !!order?.shipping_address;

  const address = hasSnapshot
    ? order.shipping_address
    : order?.address_id;

  const country = hasSnapshot
    ? address?.country?.name
    : address?.country_id?.name;

  const province = hasSnapshot
    ? address?.province?.name
    : address?.province_id?.name;

  const city = hasSnapshot
    ? address?.city?.name
    : address?.city_id?.name;

  const receiver = address?.receiver;

  return (
    <Card className="bg-white border-0 rounded-3 mb-4">
      <Card.Body className="p-4">
        <h3 className="mb-3">Detalles de Envío</h3>
        {order.carrier_id === "servientrega" || order.carrier_id === "interrapidisimo" ? (
          <div className="d-flex align-items-center mb-2">
            <span className="text-secondary">Proveedor de Envío:</span>
            <span className="ms-1">
              {order.carrier_id === "servientrega" ? "Servientrega" : "Interrapidísimo"}
            </span>
          </div>
        ) : null}
        {order.servientrega_guide? (
          <div className="d-flex align-items-center mb-2">
            <span className="text-secondary">numero de guia:</span>
            <span className="ms-1">
              {order.servientrega_guide}
            </span>
          </div>
        ) : null}
        {order.interrapidisimo_guide && (
          <div className="d-flex align-items-center mb-2">
            <span className="text-secondary">Número de guía Interrapidísimo:</span>
            <span className="ms-1">{order.interrapidisimo_guide}</span>
          </div>
        )}

        <div className="d-flex align-items-center mb-2">
          <span className="text-secondary">Fecha de Orden:</span>
          <span className="ms-1">{formatDate(order?.created_at)}</span>
        </div>

        <div className="d-flex align-items-center mb-2">
          <span className="text-secondary">Nombre de Dirección:</span>
          <span className="ms-1">{address?.name || "-"}</span>
        </div>

        <div className="d-flex align-items-center mb-2">
          <span className="text-secondary">País:</span>
          <span className="ms-1">{country || "-"}</span>
        </div>

        <div className="d-flex align-items-center mb-2">
          <span className="text-secondary">Provincia:</span>
          <span className="ms-1">{province || "-"}</span>
        </div>

        <div className="d-flex align-items-center mb-2">
          <span className="text-secondary">Ciudad:</span>
          <span className="ms-1">{city || "-"}</span>
        </div>

        <div className="d-flex align-items-center mb-2">
          <span className="text-secondary">Código Postal:</span>
          <span className="ms-1">{address?.postal_code || "-"}</span>
        </div>

        <div className="d-flex mb-2">
          <span className="text-secondary">Dirección:</span>
          <span className="ms-1">{address?.address || "-"}</span>
        </div>

        <div className="d-flex mb-2">
          <span className="text-secondary">Recibe el pedido:</span>
          <span className="ms-1">
            {receiver?.type === "other"
              ? "Otra persona"
              : "Titular"}
          </span>
        </div>

        {receiver?.type === "other" && (
          <>
            {receiver?.name && (
              <div className="d-flex mb-2">
                <span className="text-secondary">Nombre receptor:</span>
                <span className="ms-1">{receiver.name}</span>
              </div>
            )}

            {receiver?.document && (
              <div className="d-flex mb-2">
                <span className="text-secondary">Documento receptor:</span>
                <span className="ms-1">{receiver.document}</span>
              </div>
            )}

            {receiver?.phone && (
              <div className="d-flex mb-2">
                <span className="text-secondary">Teléfono receptor:</span>
                <span className="ms-1">{receiver.phone}</span>
              </div>
            )}
          </>
        )}

        {address?.observations && (
          <div className="d-flex mb-2">
            <span className="text-secondary">Observaciones:</span>
            <span className="ms-1">{address.observations}</span>
          </div>
        )}

        {order?.dropi && (
          <>
            <div className="d-flex mb-2">
              <span className="text-secondary">Transportadora:</span>
              <span className="ms-1">{order.dropi.company}</span>
            </div>

            <div className="d-flex mb-0">
              <span className="text-secondary">Número de guía:</span>
              <span className="ms-1">{order.dropi.shipping_guide}</span>
            </div>
          </>
        )}
      </Card.Body>
    </Card>
  );
};

export default ShippingDetails;